import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

interface ContactPointContacts {
  email: string[] | [];
  phone: string[] | [];
  url: string[] | [];
  pec: string[] | [];
  account: string[] | [];
  whatsapp: string[] | [];
  telegram: string[] | [];
  skype: string[] | [];
  linkedin: string[] | [];
  twitter: string[] | [];
}

interface Contact {
  title?: string;
  contact_point_body: {
    value: string;
    format: string;
    processed: string;
  };
  contact_point_contacts: ContactPointContacts;
}

interface ProcessedContact {
  title?: string;
  contact_point_body?: {
    value: string;
    format: string;
    processed: string;
  };
  contact_point_contacts: ContactPointContacts;
}

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit {
  @Input() data: Contact[] = [];

  contacts: ProcessedContact[] = [];

  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit() {
    // Process all contacts in a consistent way regardless of the count
    this.contacts = this.data.map(contact => {
      return {
        title: contact.title,
        contact_point_body: contact.contact_point_body,
        contact_point_contacts: {
          phone: this.splitContactPoints(contact?.contact_point_contacts?.phone),
          url: this.splitContactPoints(contact?.contact_point_contacts?.url),
          email: this.splitContactPoints(contact?.contact_point_contacts?.email),
          pec: this.splitContactPoints(contact?.contact_point_contacts?.pec),
          account: this.splitContactPoints(contact?.contact_point_contacts?.account),
          whatsapp: this.splitContactPoints(contact?.contact_point_contacts?.whatsapp),
          telegram: this.splitContactPoints(contact?.contact_point_contacts?.telegram),
          skype: this.splitContactPoints(contact?.contact_point_contacts?.skype),
          linkedin: this.splitContactPoints(contact?.contact_point_contacts?.linkedin),
          twitter: this.splitContactPoints(contact?.contact_point_contacts?.twitter),
        }
      };
    });
  }

  private splitContactPoints(contactPoint: string | string[] | undefined): string[] {
    if (!contactPoint) return [];
    if (Array.isArray(contactPoint)) return contactPoint;
    return contactPoint.split(';').map(point => point.trim());
  }

  sanitizeHtml(html: string): any {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}